class ContactForm {
  constructor() {
    this.form = document.querySelector('.js-contact');
    this.message = this.form.querySelector('.js-message');
    this.captcha = this.form.querySelector('.js-captcha');

    this.data = {
      fields: null,
      siteKey: this.captcha.getAttribute('data-sitekey'),
      action: this.form.getAttribute('action'),
      method: this.form.getAttribute('method'),
      params: '?action=send_mail',
      message: ''
    };

    this.script = {
      el: null,
      src: 'https://www.google.com/recaptcha/api.js?onload=initRecaptcha&render=explicit'
    };
  }

  loadScript() {
    this.script.el = document.createElement('script');
    this.script.el.setAttribute('src', this.script.src);
    this.script.el.setAttribute('data-test', this.script.src);

    document.querySelector('head').appendChild(this.script.el);
  }

  removeScript() {
    document.querySelector('script[src*="recaptcha"]').remove();
    this.script.el.remove();
    this.script.el = null;
  }

  clearBorder() {
    // if field has red border from previous validation then remove error class
    const errorFields = this.form.querySelectorAll('.contact__input--error');

    if (errorFields.length > 0) {
      [...errorFields].forEach((errorField) => errorField.classList.remove('contact__input--error'));
    }
  }

  submitForm = (e) => {
    e.preventDefault();

    this.data.fields = new FormData(this.form);

    const els = e.target.elements;

    [...els].forEach((el) => {
      this.data.params += `&${el.name}=${el.value}`;
    });

    let request = new XMLHttpRequest();

    request.onload = () => {
      if (request.readyState !== 4) return;

      const json = JSON.parse(request.responseText);

      if (request.status >= 200 && request.status < 300) {
        // success
        if (json.success === true) {
          this.data.message = `<p>${json.data[0].message}</p>`;

          // remove red borders
          this.clearBorder();
        }

        // error
        if (json.success === false && json.data && json.data.length > 0) {
          // remove red borders
          this.clearBorder();

          this.data.message = '<ul>';

          let el;
          [...json.data].forEach((error) => {
            el = this.form.querySelector(`[name="${error.field}"]`);

            if (el) el.classList.add('contact__input--error');

            this.data.message += `<li>${error.message}</li>`;
          });

          this.data.message += '</ul>';

          // reset recaptcha
          window.grecaptcha.reset();
        }
      } else {
        // error
        this.data.message = `<p>${json.data[0].message}</p>`;

        // reset recaptcha
        window.grecaptcha.reset();
      }

      this.message.innerHTML = this.data.message;
    };

    request.open(this.data.method, `${this.data.action}${this.data.params}`);
    request.send(this.data.fields);
  }

  init() {
    this.loadScript();

    window.initRecaptcha = () => {
      window.grecaptcha.render(this.captcha, {
        sitekey: this.data.siteKey
      });
    };

    this.form.addEventListener('submit', this.submitForm);
  }

  destroy() {
    this.removeScript();

    this.form.removeEventListener('submit', this.submitForm);
  }
}

export default ContactForm;
